import { Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToastModule } from 'primeng/toast';
import { HttpSpinnerComponent } from './shared/presentation/components/http-spinner/http-spinner.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToastModule, HttpSpinnerComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  protected readonly title = signal('REVid');
}
